import { FC } from "react";
import { IClassname } from "@/lib/types/classname";

export const FilterBeach: FC<IClassname> = ({ className }) => {
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.3584 19.9963C1.97405 19.9963 2.56449 19.7705 2.99982 19.3687C3.43515 18.9668 3.67972 18.4218 3.67972 17.8535C3.67972 18.4218 3.92428 18.9668 4.35961 19.3687C4.79494 19.7705 5.38538 19.9963 6.00103 19.9963C6.61668 19.9963 7.20712 19.7705 7.64245 19.3687C8.07778 18.9668 8.32235 18.4218 8.32235 17.8535C8.32235 18.4218 8.56692 18.9668 9.00225 19.3687C9.43758 19.7705 10.028 19.9963 10.6437 19.9963C11.2593 19.9963 11.8498 19.7705 12.2851 19.3687C12.7204 18.9668 12.965 18.4218 12.965 17.8535C12.965 18.4218 13.2095 18.9668 13.6449 19.3687C14.0802 19.7705 14.6706 19.9963 15.2863 19.9963C15.902 19.9963 16.4924 19.7705 16.9277 19.3687C17.363 18.9668 17.6076 18.4218 17.6076 17.8535C17.6076 18.4218 17.8522 18.9668 18.2875 19.3687C18.7228 19.7705 19.3133 19.9963 19.9289 19.9963"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
      />
      <path
        d="M8.56424 3.78446C7.77895 4.09422 7.06236 4.55561 6.45539 5.1423C5.84841 5.72899 5.36294 6.42949 5.02668 7.2038C4.69043 7.97811 4.50998 8.81107 4.49563 9.65512C4.48129 10.4992 4.63333 11.3378 4.94309 12.1231L10.923 9.76435M8.56424 3.78446C9.34953 3.47471 10.1881 3.32267 11.0322 3.33701C11.8762 3.35136 12.7092 3.53181 13.4835 3.86806C14.2578 4.20432 14.9583 4.68979 15.545 5.29677C16.1317 5.90374 16.5931 6.62033 16.9028 7.40562L10.923 9.76435M8.56424 3.78446L8.01267 2.35424M10.923 9.76435L12.9407 14.9964M12.9407 14.9964L19.012 14.9964M12.9407 14.9964L9.01245 14.9964"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
      />
    </svg>
  );
};
